// import Vue from 'vue$';
import UIkit from './uikit.min.js';
import UIKitIcons from './uikit-icons.min.js';
import '../styles/main.scss';

/*
Vue.config.devtools = false;
Vue.config.productionTip = false;
*/
UIkit.use(UIKitIcons);
window.UIkit = UIkit;

function showMessage(message, type) {
    UIkit.notification({
        message: message,
        status: type,
        pos: 'top-center',
        timeout: 7000
    });
}
window.showMessage = showMessage;

$(window).on('ajaxErrorMessage', function(event, message) {
    const messages = {
        'login wird benötigt.': "E-Mail-Adresse wird benötigt.",
        'password wird benötigt.': "Das Password wird benötigt.",
        'A user was not found with the given credentials.': "Ihre Zugangsdaten stimmen nicht.",
        'A user was found to match all plain text credentials however hashed credential "password" did not match.': "Ihre Zugangsdaten stimmen nicht.",
        'Format von login ist ungültig.': "Dies ist keine valide E-Mail-Adresse."
    }
    if (message.indexOf('as they are not activated.') === -1) {
//        message = 'Sie habe Ihren Zugang noch nicht aktiviert';
        showMessage(messages[message] ?? message, 'info');
    }
    event.preventDefault();
});
